import { useEffect, useContext, useCallback, useMemo, useState } from 'react';
import { useWindowDimensions } from '../../common/utils/windowDimensions';
import { useRouter } from 'next/router';
import UserContext from '../../common/utils/getContext';
const project = require('../../scripts/configs/project.json');

function getPropertyFilters(properties_, productDataPropertyDefaultValues) {
    return properties_.map((item) => {
        const range_boundaries = productDataPropertyDefaultValues.hasOwnProperty(item?.name)
            ? { ...productDataPropertyDefaultValues[item?.name] }
            : {};

        return {
            ...item,
            ...range_boundaries
        };
    });
}
export const usePropertiesFilters = (productData, properties) => {
    const [propertiesFilters, setPropertiesFilters] = useState(null);

    useEffect(() => {
        if (properties && productData) {
            if (properties.length && productData.properties) {
                setPropertiesFilters(getPropertyFilters(properties, productData?.properties));
            } else {
                setPropertiesFilters([]);
            }
        }
    }, [properties, productData]);

    return propertiesFilters;
};
export const getProductsSkeleton = (width) => {
    return [
        {
            row: [width, width, width, width, width, width, width, width, ...(width === 20 ? [width, width] : [])],
            items: [
                {
                    content: [
                        'image',
                        {
                            row: [90],
                            items: [
                                {
                                    type: 'text',
                                    gap: [0, 0, 1, 0]
                                }
                            ],
                            indent: 3
                        },
                        {
                            row: [80],
                            items: ['text'],
                            indent: 3
                        },
                        'empty'
                        // 'line',
                        // {
                        //     row: [29, 19, 5, 49],
                        //     items: ['text', 'text', 'empty', 'text'],
                        //     gap: 2,
                        //     indent: 3
                        // },
                        // 'empty'
                    ]
                }
            ],
            gap: 2
        }
    ];
};
export const categoriesSkeleton = [
    {
        row: [25, 75],
        gap: 2,
        vertical: 'unset',
        items: [
            {
                content: [
                    'title',
                    {
                        type: 'list',
                        size: { rows: 5 }
                    }
                ]
            },
            ...getProductsSkeleton(25)
        ]
    }
];
export const useFixedElement = (element, container) => {
    const widthDimensions = useWindowDimensions();

    const resetStyles = useCallback(() => {
        if (element.current) {
            element.current.style.position = '';
            element.current.style.top = '';
        }
    }, [element]);

    const func = useCallback(() => {
        const headerElement = document.querySelector('.store_fixed_search');

        // TODO ZOOM
        let getWithZoom = (scroll) => {
            let width = window.innerWidth;
            const zoom = Number(window.getComputedStyle(document.querySelector('html'), null).zoom);
            if (project.zooming && zoom === zoom && zoom < 1 && width < 1650 && width >= 1300) {
                return scroll / zoom;
            }
            return scroll;
        };
        // TODO ZOOM

        if (element?.current) {
            const containerElem = container?.current || element?.current.parentElement;
            const values = containerElem.getBoundingClientRect();
            const header = headerElement ? headerElement.getBoundingClientRect() : null;
            const elem = element.current.getBoundingClientRect();
            const { height } = values;
            // TODO ZOOM
            const top = containerElem.offsetTop - getWithZoom(window?.scrollY) || values.top;
            // TODO ZOOM
            const actualTop = header ? headerElement.offsetTop + header.height + 60 : 0;
            if (top < actualTop && height > elem.height) {
                element.current.style.position = 'fixed';
                if (actualTop + elem.height > top + height) {
                    element.current.style.top = `${top + height - elem.height}px`;
                } else {
                    element.current.style.top = `${actualTop}px`;
                }
            } else {
                resetStyles();
            }
        }
    }, [element, resetStyles, container]);

    useEffect(() => {
        if (widthDimensions > 992) {
            func();
            window.addEventListener('scroll', func);
        } else {
            resetStyles();
            window.removeEventListener('scroll', func);
        }
        return () => {
            window.removeEventListener('scroll', func);
        };
    }, [func, resetStyles, widthDimensions]);
};
export const useCachedData = (data) => {
    const { setState } = useContext(UserContext);
    const [stateData, setStateData] = useState(data);
    const router = useRouter();

    useEffect(() => {
        setStateData(data);
    }, [data, router.asPath]);

    const setStateFunc = useCallback(
        (data) => {
            setState('routerReLoader', true);
            setStateData(data);
        },
        [setState]
    );

    const result = useMemo(() => [stateData, setStateFunc], [stateData, setStateFunc]);
    return result;
};
